import React from 'react';
import { Editor } from "slate";
import { EditorPlugin } from "../../slate/PowerEditorConfig";
import { CustomElement } from "../../../../../slate";
import { LabelOutlined } from "@mui/icons-material";
import { FootnoteElement } from './FootnoteElement';
import { EditFootnoteCommand, FootnotePropsSchema } from './types';
import { useFootnoteEdit } from './useFootnotesEdit';
import { generateCode } from '../common';
import { DialogFieldsSection, SlateElementEditDialog } from '../common/SlateElementEditDialog';
import { FormattedMessage } from 'react-intl';



export const FootnoteElementType = "footnote";

export const withFootnotes = (editor: Editor) => {
  const { isInline, isVoid } = editor
  
  editor.isInline = (element: CustomElement) => {
    return element.type === FootnoteElementType ? true : isInline(element)
  }
  
  editor.isVoid = (element: CustomElement) => {
    return element.type === FootnoteElementType ? true : isVoid(element)
  }
  
  return editor
}


const DialogFields: DialogFieldsSection[] = [
  {
    columns: "1fr",
    fields: [
      ["label"],
      ["footnote_text", { controlProps: { autoFocus: true }}],
    ],
  },
];


export const useFootnotesEditorPlugin = (): EditorPlugin => {
  const editing = useFootnoteEdit();

  return {
    key: "footnotes",
    inject: e => withFootnotes(e),
    customBlocks: { [FootnoteElementType]: FootnoteElement },
    dialogs: editing.editingContext
      ? <>
        <SlateElementEditDialog
          data={editing}
          sections={DialogFields}
          title={<FormattedMessage id="powerdoc.plugins.footnote.dialog_title" defaultMessage="Сноска" />}
          schema={FootnotePropsSchema}
          />
        </>
      : undefined,
    commands: [{
      name: "insert-footnote",
      invoke: editor => {
        editor.insertNode({
          type: FootnoteElementType,
          _id: `ftn_${generateCode()}_${generateCode()}`,
          children: [{ text: "", }],
        } as any);
      },
      menu: { label: "Footnote", label_id: "powerdoc.plugins.footnote.title", section: "insert-item", icon: <LabelOutlined /> },
    },
    {
      name: EditFootnoteCommand,
      isInternal: true,
      invoke: (editor,element) => {
        if(element && element.type === FootnoteElementType) {
          editing.startEditing(editor, element);
        }
      },
    }],
    }
}
